.header {
  padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
  border-bottom: 1px solid var(--mantine-color-gray-3);
}

/* Mantine Drawer content element defaults to height:100% + overflow-y:auto,
   which would let the header + body overflow and scroll the whole panel —
   pushing the footer below the fold. Make it a non-scrolling flex column so
   the header and the body slot stack within the viewport. */
.drawerContent {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Mantine renders the Drawer's children (grid + footer) inside this body slot,
   so it owns the split: the grid flexes to fill, the footer stays pinned. */
.drawerBodySlot {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.drawerBody {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 590px 1fr;
  grid-template-rows: 1fr;
  overflow: hidden;
}

.formColumn {
  min-height: 0;
  overflow-y: auto;
  padding: var(--mantine-spacing-lg);
  border-right: 1px solid var(--mantine-color-gray-3);
}

.ratesColumn {
  min-height: 0;
  overflow-y: auto;
}

.footer {
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 590px 1fr;
  border-top: 1px solid var(--mantine-color-gray-3);
  background: var(--mantine-color-white);
}

.footerFormSection {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
  border-right: 1px solid var(--mantine-color-gray-3);
}

.footerRatesSection {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--mantine-spacing-sm);
  padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
}
